import React from 'react';
import {withStyles} from '@material-ui/core/styles';


function OrangeLinkWithArrows(props) {
  const {classes, ...otherProps} = props;

  return (
    <button className={classes.link} {...otherProps}>
      {props.children}
    </button>
  )
}


export default withStyles((theme) => ({
  link: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    ...theme.typography.hg18ru(theme),
    paddingBottom: '0.2em',
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    outline: 'none',
    display: 'flex',
    '&:after': {
      display: 'inline-block',
      content: "'\u2192'",
      marginLeft: '0.5em',
    },
    '&:hover:after': {
      animation: 'bounce-horizontal 1s infinite linear',
    },
  }
}))(OrangeLinkWithArrows);




// WEBPACK FOOTER //
// ./src/parts/OrangeLinkWithArrow.js